import { environment } from '../../../../environments/environment'
import { type CartoClient } from './carto.helper'

export interface PoiRow {
  cartodb_id: number
  id: number
  name: string
  category_id: number
  category_name: string
  competitor: string
  delivery_id: number
  region_id: string
  lng: number
  lat: number
  tag_ids: number[]
  tags: string[]
  properties: Record<string, any>
  nvisitors: number
  traffic: number
}

export interface PoisFilters {
  delivery_id: number
  delivery_start_date: string
  filter_combined: string
  tag_groups: number[][]
  reach?: number[]
  // Demographic columns selected by the target filter; empty = entire population.
  columns?: string[]
}

export async function fetchPois(
  cartoClient: CartoClient,
  filters: PoisFilters,
  signal?: AbortSignal,
): Promise<PoiRow[]> {
  const {
    delivery_id,
    delivery_start_date,
    filter_combined,
    tag_groups,
    reach = [],
    columns = [],
  } = filters
  const [reach_min, reach_max] =
    reach.length === 2 ? reach : [0, Number.MAX_SAFE_INTEGER]

  // CARTO rejects empty array params; ['nvisitors'] is the sentinel the
  // named source recognizes as "no target filter, use the total column".
  const columnsForApi = columns.length === 0 ? ['nvisitors'] : columns

  const response = await cartoClient.query<PoiRow>({
    source: {
      source: `${environment.CARTO_SOURCE_PREFIX}_pois_params`,
      queryParameters: {
        delivery_id,
        delivery_start_date,
        filter_combined,
        tag_groups: JSON.stringify(tag_groups ?? []),
        reach_min,
        reach_max,
        columns: columnsForApi,
      },
    },
    params: {
      column: [
        'cartodb_id',
        'id',
        'name',
        'category_id',
        'category_name',
        'competitor',
        'delivery_id',
        'region_id',
        'lng',
        'lat',
        'tag_ids',
        'tags',
        'properties',
        'nvisitors',
        'traffic',
      ],
    },
    signal,
  })

  return response?.rows ?? []
}
